import { ParseKeys, TFunction } from "i18next";

// Answers are stored in English, which vendors' services match against, so
// only the displayed label is translated.
const OPTION_KEYS: Record<string, ParseKeys<"estimator">> = {
  Tesla: "options.tesla",
  Other: "options.other",
  Detached: "options.detached",
  "Semi-Detached": "options.semi_detached",
  Townhouse: "options.townhouse",
  Outdoor: "options.outdoor",
  Indoor: "options.indoor",
  "NEMA 14-50 Outlet Only": "options.nema_outlet",
  "Tesla Wall Connector with NEMA 14-50": "options.tesla_wall_nema",
  "NEMA 14-50 With Level 2 Charger": "options.nema_level2",
  "Tesla Wall hardwired": "options.tesla_hardwired",
  "Hardwired with Level 2 Charger": "options.hardwired_level2",
  "Main Floor": "options.main_floor",
  Basement: "options.basement",
  Garage: "options.garage",
  "10 FT": "options.ft10",
  "20 FT": "options.ft20",
  "30 FT": "options.ft30",
  "40 FT": "options.ft40",
  "50 FT": "options.ft50",
  "purchase charger": "options.purchase",
  "lease-to-own charger": "options.lease",
  "provide own charger": "options.own",
  Yes: "options.yes",
  No: "options.no",
  homeowner: "options.homeowner",
  Homeowner: "options.homeowner",
  business: "options.business",
  "Business or Fleet Manager": "options.business",
  None: "options.none",
};

/** A stored answer in the current language; unknown values pass through. */
export const optionLabel = (
  t: TFunction<"estimator">,
  value?: string | null,
): string => {
  if (!value) {
    return "";
  }
  const key = OPTION_KEYS[value];
  return key ? t(key) : value;
};

/** Options with translated labels; map a pick back to the stored one by id. */
export const translateOptions = (
  t: TFunction<"estimator">,
  options: readonly { id: number; label: string }[],
) => options.map(({ id, label }) => ({ id, label: optionLabel(t, label) }));
